import { Button, Divider, Grid, Stack, Typography } from '@mui/material';
import { VoterProfileType, VoterSearchForm } from 'src/@types/voterSearch';

// components
import { CommandPaletteResult } from 'src/components/command-palette';
import { ChevronLeft } from '@mui/icons-material';
import NoResults from 'src/components/no-results';
import { VoterListItem } from 'src/components/voter-list-item';
import VoterLookupTag from './VoterLookupTag';
import { useOrg } from 'src/hooks/query/orgHooks';

type VoterLookupResultsScreenProps = {
  search: VoterSearchForm;
  results: VoterProfileType[];
  onVoterClick: (voter: VoterProfileType) => void;
  onBack?: () => void;
};

function VoterLookupResultsScreen({
  search,
  results,
  onBack,
  onVoterClick,
}: VoterLookupResultsScreenProps) {
  const { data: org } = useOrg();

  return (
    <Stack gap={2}>
      <Stack gap={1}>
        <Grid size={{ xs: 12 }} container alignItems="center" justifyContent="space-between">
          <Grid size={{ xs: 3 }}>
            <Button variant="text" color="inherit" onClick={onBack} startIcon={<ChevronLeft />}>
              Back
            </Button>
          </Grid>
          <Grid size={{ xs: 6 }}>
            <Typography variant="h5" textAlign="center">
              Voter Lookup Results
            </Typography>
          </Grid>
          <Grid size={{ xs: 3 }} />
        </Grid>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="safe center"
          gap={1}
          sx={{ overflowX: 'auto', flexWrap: 'nowrap' }}
        >
          {Object.entries(search)
            .filter(([, value]) => value && value !== '')
            .map(([key, value]) => (
              <VoterLookupTag key={key} label={key} value={value} org={org} />
            ))}
        </Stack>
      </Stack>
      <Divider />
      {!results ||
        (results.length === 0 && (
          <NoResults
            title="No Voter Found"
            description="There is no voter that matches your search values."
          />
        ))}
      {results && results.length > 0 && (
        <Stack overflow="auto" maxHeight="50vh">
          {results.map((voter) => (
            <CommandPaletteResult key={voter.numinar_id} onClick={() => onVoterClick(voter)}>
              <VoterListItem voter={voter} showAddress />
            </CommandPaletteResult>
          ))}
        </Stack>
      )}
    </Stack>
  );
}

export default VoterLookupResultsScreen;
